<style lang="scss" scoped>
.alert {
	text-align: center;
	margin-bottom: 0;
	&.marginBottom {
		margin-bottom: 20px;
	}
	&__clickable {
		cursor: pointer;
	}
	&.alert-warning-info {
		background: #ffc46b;
		text-align: left;
		padding: 31px;
		margin-bottom: 30px;
		color: #3c3c3c;
	}
}
.fade-enter-active,
.fade-leave-active {
	transition: max-height 0.5s ease-in-out;
	max-height: 200px;
}
.fade-enter,
.fade-leave-to {
	transition: max-height 0.5s ease-in-out;
	max-height: 0px;
}
/deep/ {
	.underline {
		text-decoration: underline;
	}
}
</style>

<template lang="pug">
    component(:is="sticky ? 'portal' : 'component-slot'", to="layout-top")
        transition(name="fade")
            div(v-if="display")
                .alert(:class="alertClasses", @click="$emit('click')")
                    slot
</template>

<script>
import ComponentSlot from "@/components/ui/ComponentSlot";

export default {
	components: {
		ComponentSlot,
	},
	props: {
		type: {
			type: String,
			default: "info",
			validator: (value) => ["primary", "secondary", "success", "danger", "warning", "info", "light", "dark", "warning-info"].indexOf(value) !== -1,
		},
		timer: {
			type: Number,
			default: null,
		},
		sticky: {
			type: Boolean,
			default: false,
		},
		clickable: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			display: true,
		};
	},
	computed: {
		alertClasses() {
			return {
				marginBottom: !this.sticky,
				[`alert-${this.type}`]: this.type,
				alert__clickable: this.clickable,
			};
		},
	},
	mounted() {
		if (this.timer) {
			setTimeout(() => {
				this.display = false;
			}, this.timer * 1000);
		}
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ui/Alert.vue